module.exports = __webpack_public_path__ + "media/Components/fonts/Teko-7a95ca68e10f99abf9f72a3eb7b6afe0.ttf";